import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a872283e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/banner-popup/_banner-popup.scss?vue&type=style&index=0&id=a872283e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a872283e",
  null
  
)

export default component.exports